import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Planner from "@/pages/Planner";
import Library from "@/pages/Library";
import Garden from "@/pages/Garden";
import PlantDetail from "@/pages/PlantDetail";
import Harvest from "@/pages/Harvest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/planner" element={<Planner />} />
            <Route path="/library" element={<Library />} />
            <Route path="/garden" element={<Garden />} />
            <Route path="/garden/:id" element={<PlantDetail />} />
            <Route path="/harvest" element={<Harvest />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" toastOptions={{ className: "font-sans" }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
